import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RotateCcw, Trash2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const QuoteTrashNotice = ({ quote, onRestored, preserveDraft = false }) => {
  const navigate = useNavigate();
  const restoringRef = useRef(false);
  const [restoring, setRestoring] = useState(false);
  const [error, setError] = useState('');

  const restore = async () => {
    if (restoringRef.current) return;
    restoringRef.current = true;
    setRestoring(true);
    setError('');
    try {
      const response = await fetch(`${API_URL}/api/admin/quotes/${quote.id}/restore`, {
        method: 'POST',
        headers: { Authorization: `Basic ${btoa(':' + sessionStorage.getItem('admin_password'))}` },
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.detail || 'Could not restore this quote. Please try again.');
      }
      onRestored();
    } catch (err) {
      setError(err.message);
    } finally {
      restoringRef.current = false;
      setRestoring(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-12" data-testid="quote-trash-guard">
      <section className="mx-auto max-w-2xl border-l-4 border-amber-500 pl-6" role="alert">
        <Trash2 className="mb-4 h-8 w-8 text-amber-700" aria-hidden="true" />
        <h1 className="text-2xl font-bold text-foreground" data-testid="quote-trash-title">This quote is in Trash</h1>
        <p className="mt-3 break-words text-foreground/80" data-testid="quote-trash-identity">
          {quote.quote_number || 'Quote'}{quote.client_name ? ` · ${quote.client_name}` : ''}
        </p>
        <p className="mt-3 text-sm text-foreground/70" data-testid="quote-trash-message">
          Restore it before editing. It will then appear in your active Quotations list.
          {preserveDraft && ' Your unsaved changes are still here; save them after restoring.'}
        </p>
        {error && <p className="mt-4 text-sm text-red-700" data-testid="quote-restore-error">{error}</p>}
        <div className="mt-6 flex flex-wrap gap-3">
          <button type="button" onClick={restore} disabled={restoring} data-testid="quote-restore-button"
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-white transition-colors hover:bg-primary/90 disabled:opacity-50">
            <RotateCcw className="h-4 w-4" />{restoring ? 'Restoring…' : 'Restore quote'}
          </button>
          <button type="button" onClick={() => navigate('/admin/quotes?tab=trash')} disabled={restoring}
            data-testid="quote-back-to-trash" className="rounded-lg border border-border px-4 py-2 transition-colors hover:bg-white">
            Back to Trash
          </button>
        </div>
      </section>
    </div>
  );
};